/* eslint-disable brace-style */
/* eslint-disable comma-dangle */
/* eslint-disable no-console */
(function (Drupal, Swiper) {
  'use strict';

  if (typeof Swiper === 'undefined') {
    console.warn(
      'Swiper library not found. Marquee component will not initialize.'
    );
    return;
  }

  // Hardcoded Swiper options for horizontal marquee
  const MARQUEE_OPTIONS = {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 'auto',
    grabCursor: false,
    speed: 5000,
    preventClicks: true,
    roundLengths: true,
    freeMode: {
      enabled: false,
      sticky: false,
      momentum: false,
    },
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      reverseDirection: false,
      pauseOnMouseEnter: false,
      stopOnLastSlide: false,
    },
  };

  const CONTENT_DUPLICATION_FACTOR = 10;

  let marqueeInstanceCounter = 0;
  function generateUniqueId() {
    marqueeInstanceCounter++;
    return `swiper-marquee-${marqueeInstanceCounter}`;
  }

  Drupal.behaviors.mySwiperMarquee = {
    attach: function (context, settings) {
      // Check for prefers-reduced-motion
      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      const marqueeContainers = context.querySelectorAll(
        '.animated-ribbon:not([data-marquee-initialized])'
      );

      marqueeContainers.forEach(container => {
        const wrapper = container.querySelector('.animated-ribbon__marquee');
        const swiperWrapper = wrapper.querySelector('.swiper-wrapper');
        const button = container.querySelector(
          '.animated-ribbon__toggle-button'
        );

        const uniqueId = generateUniqueId();
        wrapper.id = uniqueId;

        container.setAttribute('data-marquee-initialized', 'true');

        const contentSource = wrapper.querySelector(
          '.animated-ribbon__marquee-contents'
        );

        if (!contentSource) {
          console.warn(
            `Content source div not found for Swiper marquee ID: ${uniqueId}.`
          );
          return;
        }

        /* Originally, we expected a UL inside the content source */
        /* We'll fix that later. For now, just grab all direct children. */
        const divContainer = contentSource.querySelector('div:first-child');
        if (!divContainer) {
          console.warn(
            `DIV element not found within content source for Swiper marquee ID: ${uniqueId}.`
          );
          container.setAttribute('data-marquee-initialized', 'false');
          // contentSource.remove();
          return;
        }

        const originalListItems = Array.from(divContainer.children).filter(
          div => div.tagName === 'DIV'
        );
        if (originalListItems.length === 0) {
          console.warn(
            `No DIV elements found in DIV for Swiper marquee ID: ${uniqueId}.`
          );
          // contentSource.remove();
          return;
        }

        swiperWrapper.innerHTML = '';

        for (let i = 0; i < CONTENT_DUPLICATION_FACTOR; i++) {
          originalListItems.forEach(div => {
            const slide = document.createElement('div');
            slide.classList.add('swiper-slide');
            slide.innerHTML = div.innerHTML;
            swiperWrapper.appendChild(slide);
          });
        }

        contentSource.remove();

        // Adjust Swiper options based on prefersReducedMotion
        const finalMarqueeOptions = Object.assign({}, MARQUEE_OPTIONS); // Clone the default options
        if (prefersReducedMotion) {
          finalMarqueeOptions.autoplay = false; // Disable autoplay entirely
          finalMarqueeOptions.loop = false; // Disable loop to prevent jumps
          finalMarqueeOptions.allowTouchMove = false; // Prevent manual dragging
          console.log(
            `Reduced motion detected for marquee ID: ${uniqueId}. Autoplay disabled.`
          );
        }

        const mySwiper = new Swiper(wrapper, finalMarqueeOptions);

        // Play/Pause Button Logic
        // Only show/enable button if autoplay is active
        if (prefersReducedMotion) {
          button.style.display = 'none'; // Hide the button if no animation
          // Or, you could change its text to "Animation Disabled" and disable it.
        } else {
          let isPausedByButton = false;
          button.setAttribute('aria-pressed', 'false'); // Initial state for aria-pressed

          button.addEventListener('click', function () {
            if (isPausedByButton) {
              mySwiper.autoplay.start();
              button.setAttribute('aria-pressed', 'false');
              isPausedByButton = false;
              console.log('Swiper resumed by button:', uniqueId);
            } else {
              mySwiper.autoplay.stop();
              button.setAttribute('aria-pressed', 'true');
              isPausedByButton = true;
              console.log('Swiper paused by button:', uniqueId);
            }
          });
        }

        wrapper.__swiperInstance = mySwiper;
      });
    },

    detach: function (context, settings, trigger) {
      if (trigger === 'unload' || trigger === 'dom_removed') {
        const marqueeContainers = context.querySelectorAll(
          '.animated-ribbon[data-marquee-initialized]'
        );
        marqueeContainers.forEach(container => {
          const wrapper = container.querySelector('.animated-ribbon__marquee');
          const button = container.querySelector(
            '.animated-ribbon__toggle-button'
          );

          if (wrapper.__swiperInstance) {
            wrapper.__swiperInstance.destroy(true, true);
            delete wrapper.__swiperInstance;
          }
          if (button && !button.style.display) {
            // Only remove listener if button was visible
            // If the event listener was added with an anonymous function,
            // you can't remove it directly with removeEventListener unless you store a reference.
            // For robustness, store the function reference.
            // Example: button.removeEventListener('click', container.__buttonClickHandler);
            // delete container.__buttonClickHandler;
          }
          container.removeAttribute('data-marquee-initialized');
        });
      }
    },
  };
})(Drupal, window.Swiper);
